import React, { useState } from "react"
import { isMobile } from "react-device-detect"
import { useSelector } from "react-redux"
import { redirectToOmnicuris } from "../utilities"
import { DefaultProfileIcon } from "../utilities/resources"
import ExpertsBottomSheet from "./ExpertsBottomSheet"
import ExpertsTooltip from "./ExpertsTooltip"
import Img from "./Img"
import homeoutlined from "../../src/assets/images/homeoutlined.png"
import graduate from "../../src/assets/images/graduate.png"
function Experts2(props) {
  const { id, media, name, qualification, location, index, bio } = props
  const { domainDetails } = useSelector((state) => state.listings)
  const [visible, setVisible] = useState(false)

  const navigate = (ev, id) => {
    ev.stopPropagation()
    // if (domainDetails && domainDetails.orgType === 'certifier') {
    //   redirectToOmnicuris(`/expert/${id}`, window.self != window.top);
    // } else {
    return false
    // }
  }

  return (
    <section className="expertsTiles fadeInUp" style={{ animationDelay: `${index * 0.15}s`, cursor: domainDetails && domainDetails.orgType !== "certifier" ? "default" : "pointer" }}>
      <figure className="expertsTilesMedia" onClick={() => setVisible(true)}>
        <Img src={media} defaultSrc={DefaultProfileIcon} alt="" />
      </figure>
      <article className="expertsTilesContent" onClick={() => setVisible(true)}>
        <h4>{name}</h4>
        <p>{qualification}</p>
        <p>{location}</p>
      </article>
      <ExpertsTooltip name={name} qualification={qualification} location={location} bio={bio} />
      {isMobile && <ExpertsBottomSheet visible={visible} setVisible={setVisible} name={name} profilePic={media} qualification={qualification} location={location} bio={bio} />}
    </section>
  )
}

export default Experts2
